var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"supplier-login",attrs:{"fluid":""}},[_c('v-img',{staticClass:"supplier-login__logo",attrs:{"width":300,"max-height":100,"src":require("../../assets/img/logo.png")}}),_c('SuppliersLoginForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }